import { render } from "./PengajuanKerjasama.vue?vue&type=template&id=134681e5"
import script from "./PengajuanKerjasama.vue?vue&type=script&lang=js"
export * from "./PengajuanKerjasama.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__